/* Evivo – hareket, kaydırmalı hikâye, bölge popup'ı, kampanya sayacı */
(function () {
  var root = document.documentElement;

  /* ---------- Sayaç (sayılar bölümü) ---------- */
  function countUp(el) {
    if (el.dataset.done) return;
    el.dataset.done = '1';
    var raw = el.dataset.to || '0';
    var to = parseFloat(raw.replace(',', '.')) || 0;
    var dec = (raw.split(/[.,]/)[1] || '').length;
    var dur = 1500, t0 = null;
    function fmt(v) { return v.toLocaleString('tr-TR', { minimumFractionDigits: dec, maximumFractionDigits: dec }); }
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      el.textContent = fmt(to * (1 - Math.pow(1 - p, 3)));
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
    setTimeout(function () { el.textContent = fmt(to); }, dur + 300);
  }

  function reveal(el) {
    el.classList.add('is-in');
    el.querySelectorAll('[data-to]').forEach(countUp);
  }

  function initReveal(scope) {
    var items = (scope || document).querySelectorAll('.mg-r, .mg-words, .mg-stats__cell');
    if (!('IntersectionObserver' in window)) { root.classList.add('mg-noio'); items.forEach(reveal); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Kaydırmaya bağlı: hikâye adımları + paralaks ---------- */
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    (window.requestAnimationFrame || setTimeout)(function () { ticking = false; paint(); });
  }
  function paint() {
    var vh = window.innerHeight;
    document.querySelectorAll('[data-mg-story]').forEach(function (sec) {
      var steps = sec.querySelectorAll('[data-mg-story-step]');
      if (!steps.length) return;
      var list = sec.querySelector('.mg-how__steps');
      var r = list.getBoundingClientRect();
      var p = Math.min(Math.max((vh * 0.55 - r.top) / r.height, 0), 1);
      var bar = sec.querySelector('[data-mg-story-bar]');
      if (bar) bar.style.height = (p * 100) + '%';
      var active = steps[0];
      steps.forEach(function (st) { if (st.getBoundingClientRect().top < vh * 0.6) active = st; });
      steps.forEach(function (st) { st.classList.toggle('is-on', st === active); });
      var num = sec.querySelector('[data-mg-story-num]');
      if (num) num.textContent = active.dataset.mgStoryStep;
    });
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[data-mg-parallax]').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      var k = parseFloat(el.dataset.mgParallax) || 0;
      var off = (r.top + r.height / 2 - vh / 2) * k;
      el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  /* ---------- Bölgeler: ekranın ortasında modal ---------- */
  var zoneBackdrop = null;
  function zonePop(box) {
    if (!box._pop) {
      box._pop = box.querySelector('.mg-zones__pop');
      if (box._pop) { box._pop._box = box; document.body.appendChild(box._pop); }
    }
    return box._pop;
  }
  function openZone(box, i) {
    var pop = zonePop(box);
    if (!pop) return;
    if (!zoneBackdrop) {
      zoneBackdrop = document.createElement('div');
      zoneBackdrop.className = 'mg-zones__backdrop';
      document.body.appendChild(zoneBackdrop);
      zoneBackdrop.addEventListener('click', closeAllZones);
    }
    pop.querySelectorAll('.mg-zones__card').forEach(function (c) { c.hidden = c.dataset.i !== i; });
    box.querySelectorAll('.mg-zones__dot, .mg-zones__item').forEach(function (n) { n.classList.toggle('is-on', n.dataset.i === i); });
    pop.hidden = false;
    zoneBackdrop.classList.add('is-on');
    document.documentElement.classList.add('mg-modal-open');
    var close = pop.querySelector('.mg-zones__close');
    if (close) close.focus({ preventScroll: true });
  }
  function closeAllZones() {
    document.querySelectorAll('.mg-zones__pop').forEach(function (pop) {
      pop.hidden = true;
      if (pop._box) pop._box.querySelectorAll('.is-on').forEach(function (n) { n.classList.remove('is-on'); });
    });
    if (zoneBackdrop) zoneBackdrop.classList.remove('is-on');
    document.documentElement.classList.remove('mg-modal-open');
  }
  document.addEventListener('click', function (e) {
    var trg = e.target.closest('.mg-zones__dot, .mg-zones__item');
    if (trg) { e.preventDefault(); openZone(trg.closest('.mg-zones'), trg.dataset.i); return; }
    if (e.target.closest('.mg-zones__close')) { closeAllZones(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAllZones(); });

  /* ---------- "Paketini seç" butonları: ürün formuna kaydır ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-mg-buy]');
    if (!a) return;
    var t = document.querySelector('.quantity-breaks-container') || document.querySelector('product-form');
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  /* ---------- Geri sayım: oturum (X dk, sessionStorage) veya gerçek bitiş tarihi ---------- */
  function pad(n) { return String(n).padStart(2, '0'); }
  var SKEY = 'magrelis_session_timer_v1';
  function sessionEnd(min) {
    var fresh = Date.now() + min * 60000;
    try {
      var saved = Number(sessionStorage.getItem(SKEY));
      if (Number.isFinite(saved) && saved > 0 && saved <= fresh) return saved;
      sessionStorage.setItem(SKEY, String(fresh));
    } catch (e) {}
    return fresh;
  }
  function tickTimers() {
    document.querySelectorAll('[data-mg-cd]').forEach(function (w) {
      var end;
      if (w.dataset.minutes) {
        if (!window.__mgSessEnd) window.__mgSessEnd = sessionEnd(parseInt(w.dataset.minutes, 10) || 10);
        end = window.__mgSessEnd;
      } else {
        end = Date.parse(w.dataset.end);
      }
      if (isNaN(end)) { w.hidden = true; return; }
      var left = Math.max(0, end - Date.now());
      if (left <= 0) {
        if (!w.classList.contains('is-ended')) {
          w.classList.add('is-ended');
          var lbl = w.querySelector('[data-mg-cd-label]');
          if (lbl) lbl.textContent = w.dataset.ended || 'Süre doldu';
          w.querySelectorAll('.mg-cd__label:not([data-mg-cd-label])').forEach(function (x) { x.hidden = true; });
        }
        return;
      }
      var s = Math.floor(left / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      var dEl = w.querySelector('[data-d]'), dSep = w.querySelector('[data-dsep]'), hEl = w.querySelector('[data-h]');
      if (dEl) { dEl.hidden = d === 0; dSep.hidden = d === 0; dEl.textContent = d; }
      if (hEl) hEl.textContent = pad(h); else m += h * 60;
      w.querySelector('[data-m]').textContent = pad(m);
      w.querySelector('[data-s]').textContent = pad(s);
    });
  }
  if (!window.__mgCdInterval) window.__mgCdInterval = setInterval(tickTimers, 1000);


  /* ---------- Ürün galerisi: liste yüksekliği o an görünen görsele eşit ---------- */
  function fitGallery(list) {
    var items = [].slice.call(list.querySelectorAll('.product__media-item')).filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var active = list.querySelector('.product__media-item.is-active');
    if (!active || active.offsetParent === null) {
      var x = list.scrollLeft, best = items[0], d = Infinity;
      items.forEach(function (el) { var dd = Math.abs(el.offsetLeft - list.offsetLeft - x); if (dd < d) { d = dd; best = el; } });
      active = best;
    } else if (list.scrollWidth > list.clientWidth + 4) {
      var x2 = list.scrollLeft, best2 = active, d2 = Infinity;
      items.forEach(function (el) { var dd = Math.abs(el.offsetLeft - list.offsetLeft - x2); if (dd < d2) { d2 = dd; best2 = el; } });
      active = best2;
    }
    var h = active.offsetHeight;
    if (h > 40) list.style.height = h + 'px';
  }
  function buildPills(list) {
    var gallery = list.closest('media-gallery');
    if (!gallery || gallery.querySelector('.mg-pills')) return;
    var items = [].slice.call(list.querySelectorAll('.product__media-item')).filter(function (el) { return getComputedStyle(el).display !== 'none'; });
    if (items.length < 2) return;
    var box = document.createElement('div');
    box.className = 'mg-pills';
    items.forEach(function (el, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', (i + 1) + '. görsel');
      b.addEventListener('click', function () { list.scrollTo({ left: el.offsetLeft - list.offsetLeft, behavior: 'smooth' }); });
      box.appendChild(b);
    });
    var viewer = list.closest('slider-component') || list;
    viewer.parentNode.insertBefore(box, viewer.nextSibling);
    function sync() {
      var x = list.scrollLeft, idx = 0, d = Infinity;
      items.forEach(function (el, i) { var dd = Math.abs(el.offsetLeft - list.offsetLeft - x); if (dd < d) { d = dd; idx = i; } });
      [].forEach.call(box.children, function (p, i) { p.classList.toggle('is-on', i === idx); });
    }
    list.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
    sync();
  }
  function initGallery(scope) {
    (scope || document).querySelectorAll('.product__media-list').forEach(function (list) {
      if (list.dataset.mgFit) return;
      list.dataset.mgFit = '1';
      var t;
      var run = function () { clearTimeout(t); t = setTimeout(function () { fitGallery(list); }, 80); };
      list.addEventListener('scroll', run, { passive: true });
      window.addEventListener('resize', function () { list.style.height = ''; run(); });
      list.querySelectorAll('img').forEach(function (img) { if (!img.complete) img.addEventListener('load', run, { once: true }); });
      if ('MutationObserver' in window) new MutationObserver(run).observe(list, { subtree: true, attributes: true, attributeFilter: ['class'] });
      buildPills(list);
      run();
    });
  }

  function init(scope) { initReveal(scope); paint(); tickTimers(); initGallery(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
